import { IIconProps } from "./types"

export default function IconVec5(props: IIconProps) {
  const width = props.size || props.width || 46
  const height = props.size || props.height || 15
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 46 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.6373 13.1346C24.0526 13.6569 19.4543 14.1621 14.6854 14.1621C9.91645 14.1621 4.9565 13.6569 2.47994 13.4009C-3.43323e-05 13.1347 0 13.1346 0 13.1346V8.42731H28.6373V13.1346Z"
        fill="#3A3939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.05395 1.03779C6.70347 0.518921 11.3427 0 16.1799 0C21.0034 0 26.0247 0.518904 28.532 0.785164C31.0358 1.03777 31.0359 1.03779 31.0359 1.03779V5.86461H2.05395V1.03779Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46 11.9346H38.3111V15L31.6865 10.9071L38.3111 6.80052V9.87961H46V11.9346Z"
        fill="#3A3939"
      />
    </svg>
  )
}
